<div class="progress-container">
  <svg viewBox="0 0 100 100" class="circle">
    <circle cx="50" cy="50" r="45" class="bg" />
    <circle cx="50" cy="50" r="45" class="progress" [attr.stroke-dasharray]="circumference"
      [attr.stroke-dashoffset]="circumference - (val / 100) * circumference" [attr.stroke]="color" />
    <text x="50" y="55" class="value" [attr.fill]="color">{{ value }}</text>
  </svg>
  <div class="label" [style.color]="color">
    <div class="line1">{{ label }}</div>
  </div>
</div>